'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = TableToolbar;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function TableToolbar(_ref) {
  var _ref$children = _ref.children;
  var children = _ref$children === undefined ? null : _ref$children;
  var _ref$className = _ref.className;
  var className = _ref$className === undefined ? '' : _ref$className;
  var _ref$colSpan = _ref.colSpan;
  var colSpan = _ref$colSpan === undefined ? 1 : _ref$colSpan;
  var _ref$style = _ref.style;
  var style = _ref$style === undefined ? {} : _ref$style;

  return _react2['default'].createElement(
    'tr',
    { className: (0, _classnames2['default'])('toolbar', _classnames2['default']) },
    _react2['default'].createElement(
      'th',
      {
        colSpan: colSpan,
        style: Object.assign({
          paddingLeft: 0
        }, style) },
      children
    )
  );
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/table/toolbar.js
// module id = 341
// module chunks = 0